import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { purchaseOrderReducer } from "./PurchaseOrder";
import AddressDropdownReducer from "./AddressDropdown";
import { salesOrderReducer } from "./ConfirmSalesOrders";
import { userReducer } from "./User";
import { ticketReducer } from "./Tickets";
import { retailerReducer } from "./Retailers";

const exportReducers = (history) => {
  return combineReducers({
    router: connectRouter(history),
    userReducer: userReducer,
    retailerReducer: retailerReducer,
    purchaseOrderReducer: purchaseOrderReducer,
    addressDropdown: AddressDropdownReducer,
    salesOrderReducer: salesOrderReducer,
    ticketReducer: ticketReducer,
  });
};

export default exportReducers;
